export class ItemGrouping {
  itemGroupingId: number;
  name: string;
  displayName: string;
  displayOrder: number;
}
